<p-dialog header={{title}} [(visible)]="display"
  [transitionOptions]="'150ms cubic-bezier(0, 0, 0.2, 1)'" [modal]="true" [style]="{width: '40vw'}" [draggable]="true" (onHide)="close($event)"
  styleClass="pDialog" [contentStyle]="{'overflow-y':'visible','max-height':'80%', 'min-height':'30%', 'min-width':'30%'}"  [breakpoints]="{ 
    '2000px': '40vw',
    '1800px': '45vw',
    '1700px': '50vw',
    '1600px': '55vw',
    '1100px': '60vw',
    '900px': '65vw',
    '700px': '70vw'
  }">

  <div class="ui-grid ui-grid-responsive ui-fluid">

    <div class="ui-grid-row">
      <div class="ui-grid-col-12">
        @for (msg of messages; track msg) { <p-message [severity]="msg.severity" [text]="msg.detail"></p-message> }
      </div>
    </div>

    <p-tabs styleClass="customTabView" #tv value="0" style="margin-top: 1rem; display: block;">
      <p-tablist>
        <p-tab value="0">{{zoneGroupLabel}}</p-tab>
        <p-tab value="1">{{fleetsLabel}}</p-tab>
      </p-tablist>

      <!-- ZONE GROUP DATA PANEL -->
      <p-tabpanel value="0" class="tabPanel">

        <div (click)="focusOutOfMap()">
          <div class="container">

            <!-- ROW 1 -->
            <!-- <div class="row align-items-center">

            <div class="col">
              <form-input [required]="true" i18n-fieldName fieldName={{nameLabel}} [errors]="errors.name">
                <input pInputText id="name" [(ngModel)]="entity.name" [style]="{'width':'100px'}" />
              </form-input>
            </div>

            <div class="col">
              <form-input i18n-fieldName fieldName={{headquartersLabel}} [errors]="errors.headquarters">
                <div class="d-flex justify-content-center">
                  <p-checkbox [(ngModel)]="entity.headquarters" binary="true"></p-checkbox>
                </div>
              </form-input>
            </div>

          </div> -->



          <!-- ROW 1 -->
          <div class="row ">

            <!-- NAME  text-md-end-->
            <div class="col-xl-8 col-md-8 mt-1">
              <div class="row align-items-left">
                <div class="col-xxl-3 col-xl-3 col-md-3 col-sm-12 ">
                  <label for="name" class="custom-label" i18n>{{nameLabel}} </label>
                </div>
                <div class="col-xxl-9 col-xl-9 col-md-9 col-sm-12">
                  <input type="text" name="name" id="code" class="form-control"
                    [style]="{'width': '100%'}"  [(ngModel)]="entity.name">
                </div>
              </div>
            </div>
            <!-- EVENTS -->
            @if (user.isAdmin) {
              <div class="col-xl-3 col-md-3 mt-1">
                <div class="row  align-items-left">
                  <div class="col-xxl-7 col-xl-7 col-md-8 col-sm-12 ">
                    <label for="numevents" class="custom-label" i18n>{{eventsLabel}} </label>
                  </div>
                  <div class="col-xxl-5 col-xl-5 col-md-4 col-sm-12">
                    <p-select [options]="numevents" [(ngModel)]="entity.numEventsValid"
                    [style]="{'width':'auto'}"></p-select>
                  </div>
                </div>
              </div>
            }

          </div>

          <!-- ROW 2 -->
          <div class="row mt-4">
            <!-- SEU -->
            <div class="col-xl-4 col-md-4 mt-1">
              <div class="row  align-items-left">
                <div class="col-xxl-3 col-xl-3 col-md-3 col-sm-12 ">
                  <label for="headquarters" class="custom-label" i18n>{{headquartersLabel}} </label>
                </div>
                <div class="col-xxl-9 col-xl-9 col-md-9 col-sm-12">
                  <p-checkbox [(ngModel)]="entity.headquarters" binary="true"></p-checkbox>
                  <!-- <input type="text" name="headquarters" id="code" class="form-control"
                  [style]="{'width': '100%'}"  [(ngModel)]="entity.headquarters"> -->
                </div>
              </div>
            </div>
            <!-- PLANNER -->
            <div class="col-xl-4 col-md-4 mt-1">
              <div class="row   align-items-left">
                <div class="col-xxl-7 col-xl-7 col-md-8 col-sm-12 ">
                  <label for="routeScheduler" class="custom-label" i18n>{{plannerLabel}}  </label>
                </div>
                <div class="col-xxl-4 col-xl-4 col-md-4 col-sm-12">
                  <p-checkbox [(ngModel)]="entity.routeScheduler" binary="true"></p-checkbox>
                </div>
              </div>
            </div>
            <!-- ENABLED -->
            <div class="col-xl-4 col-md-4 mt-1">
              <div class="row   align-items-left">
                <div class="col-xxl-7 col-xl-7 col-md-8 col-sm-12 ">
                  <label for="enabled" class="custom-label" i18n>{{enabledLabel}}  </label>
                </div>
                <div class="col-xxl-4 col-xl-4 col-md-4 col-sm-12">
                  <p-checkbox [(ngModel)]="entity.enabled" binary="true"></p-checkbox>
                </div>
              </div>
            </div>

          </div>

          <!-- ROW 2 -->
          <!-- <div class="row align-items-center">

          <div class="col">
            <form-input i18n-fieldName fieldName={{enabledLabel}} [errors]="errors.enabled">
              <div class="d-flex justify-content-center">
                <p-checkbox disabled="true" [(ngModel)]="entity.enabled" binary="true"></p-checkbox>
              </div>
            </form-input>
          </div>

          <div class="col">
            <form-input i18n-fieldName fieldName={{eventsLabel}} [errors]="errors.numEventsValid"
              *ngIf="user.isAdmin">
              <p-select [options]="numevents" [(ngModel)]="entity.numEventsValid"
              [style]="{'width':'auto'}"></p-select>
            </form-input>
          </div>

        </div> -->

      </div>
    </div>

    <!-- <div (click)="focus()">
    <div class="disableDIV" #mapPH *ngIf="showMap">
      <app-custom-map #map mapId="map-zoneGroup" [display]="display" [options]="customMapOptions"
      [zones]="entity.zones" (loadMap)="initMapAfterViewInit($event)"></app-custom-map>
    </div>
  </div> -->

</p-tabpanel>

<!-- FLEETS PANEL -->
<p-tabpanel value="1" class="tabPanel">

  @if (display) {
    <div (click)="focusOutOfMap()">
      <div class="ui-g" [style]="{'overflow-y':'auto', 'overflow-x':'hidden', 'max-height':'340px'}">
        <app-fleet-tree [viewDisableds]=false [(selection)]="fleetsGroupsAndVehiclesSelected"
        [cascadeSelection]=true [selectableEntities]=false></app-fleet-tree>
      </div>
    </div>
  }
</p-tabpanel>

</p-tabs>
</div>

<ng-template pTemplate="footer">
  <div class="d-flex justify-content-end">
    @if (disableSave === false) {
      <div>
        <button type="button" class="btn custom-button" (click)="savegroup()">
          <i class="fa fa-check"></i> {{saveLabel}}
        </button>
      </div>
    }

    @if (disableSave === true) {
      <div>
        <div style="display: inline-block;" i18n-pTooltip pTooltip="{{'general.noPermissionsUpdate' | translate}}" tooltipPosition="top">
          <button disabled type="button" class="btn custom-button">
            <i class="fa fa-check"></i> {{saveLabel}}
          </button>
        </div>
      </div>
    }

    @if (isNew === false) {
      <div style="margin-left: 0.5rem;">
        @if (disabeChangeStatus === false) {
          <div>
            <button type="button" class="btn custom-button" (click)="changeStatus(!entity.enabled)">
              <i class="fa fa-check"></i> {{changeStatusLabel}}
            </button>
          </div>
        }
        @if (disabeChangeStatus === true) {
          <div>
            <div style="display: inline-block;" i18n-pTooltip pTooltip="{{'general.noPermissionsChangeStatus' | translate}}"
              tooltipPosition="top">
              <button disabled type="button" class="btn custom-button">
                <i class="fa fa-check"></i> {{changeStatusLabel}}
              </button>
            </div>
          </div>
        }
      </div>
    }

  </div>
</ng-template>

</p-dialog>